/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useRef } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import {
  Row, Col, Card, CardBody, CardText, Button, CardHeader,
  InputGroup,
} from 'reactstrap';
import { get, post } from '../../helpers/api_helper';

function HappyReturnsSale(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t, reference } = props;

  const [data, setData] = useState(null);
  const [signal, setSignal] = useState(0);
  const [concluded, setConcluded] = useState([]);
  const typeRef = useRef(null);

  const getHappyReturns = async () => {
    try {
      const res = await get(`/api/happyreturns/itemsByOrderRef/${reference.reference1}`);

      if (res !== '') {
        setData(res);
      } else {
        setData(null);
      }
    } catch (e) {
      toastr.error(t('Error loading Happy Returns data'));
    }
  };

  useEffect(() => {
    getHappyReturns();
  }, [reference, signal]);

  const approve = async (expressCode, itemId) => {
    try {
      const types = {
        damaged: 'damaged',
        sellable: 'sellable',
        missing: 'missing',
        wrongItem: 'wrongItem',
      };

      const type = types[typeRef.current.value];
      const isApproved = ['sellable'].includes(type);

      await post(`/api/happyreturns/approve/${expressCode}/${itemId}/${isApproved ? '1' : '0'}`, {
        condition: type,
      });

      const arr = [...concluded];
      arr.push(itemId);
      setConcluded(arr);

      setSignal(signal + 1);
      toastr.success(t('Return approved on Happy Returns', 'Success'));
    } catch (error) {
      toastr.error(error.message, 'Error concluding return');
    }
  };

  const unallowedPaymentMethods = ['Apple Pay'];

  const jsx = (
    <>
      {data !== null && (
        <Row>
          {data.items.map((item, index) => (
            <Col sm="4" md="4" lg="4" key={`itm_${index}`}>
              <Card>
                <CardHeader className="bg-transparent border-bottom">
                  {t('Happy Returns Item')}
                </CardHeader>
                <CardBody>
                  <h6>
                    {item.sku}
                    <br />
                    {item.productName}
                    <br />
                    <strong>{item.happyReturnsExpressCode}</strong>
                  </h6>
                  <CardText>
                    <strong>{t('Return Reason:')}</strong>
                    {' '}
                    {item.returnReason}
                    <br />
                    <strong>{t('Reason Note:')}</strong>
                    {' '}
                    {item.returnReasonNote || t('No additional notes')}
                    <br />
                    <strong>{t('Customer Intent:')}</strong>
                    {' '}
                    <strong className="text-danger">{item.refundType}</strong>
                  </CardText>
                  {item.returnShipmentLabelUrl && (
                    <Button
                      color="primary"
                      size="sm"
                      href={item.returnShipmentLabelUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-soft-primary"
                    >
                      {t('Download Return Label')}
                    </Button>
                  )}
                  <br />
                  {item.approvedAt === null && !concluded.includes(item.happyReturnsItemID)
                    && !unallowedPaymentMethods.includes(reference.payment_method) && (
                    <>
                      <br />
                      <InputGroup>
                        <select className="form-control" ref={typeRef}>
                          <option value="sellable">{t('Good (Refund)')}</option>
                          <option value="damaged">{t('Damaged')}</option>
                          <option value="missing">{t('Missing Parts')}</option>
                          <option value="wrongItem">{t('Wrong Item')}</option>
                        </select>
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => {
                            approve(item.happyReturnsExpressCode, item.happyReturnsItemID);
                          }}
                        >
                          {t('Conclude')}
                        </Button>
                      </InputGroup>
                    </>
                  )}
                  <CardText className="mt-3">
                    <strong>Tracking:</strong>
                    {' '}
                    {item.returnShipmentTracking}
                    {' ('}
                    {item.returnShipmentCarrier}
                    )
                  </CardText>
                  <CardText>
                    <strong>Value:</strong>
                    {' '}
                    {item.value}
                    {' '}
                    {item.currencyCode}
                  </CardText>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      )}

      {data === null && (
        <div />
      )}
    </>
  );

  return jsx;
}

HappyReturnsSale.defaultProps = {
  t: (w) => w,
};

HappyReturnsSale.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  reference: PropTypes.object.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(HappyReturnsSale));
